import React from 'react'
import './Spin.css'

export default () => (
  <section className="Spin">
    <div className="three-bounce">
      拼命加载中...(*╹▽╹*)
    </div>
  </section>
)
